export default __webpack_public_path__ + "static/media/eco-city.1084c703.svg";